import { cx, styled } from "simplydo/react/styled";

import type { PlaceholderHeaderProps } from "./Placeholder.types";
import { PlaceholderParagraph } from "./PlaceholderParagraph";

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;

  &.is-image::before {
    content: "";
    width: 2.5em;
    height: 2.5em;
    margin-right: 0.75em;
    border-radius: 500rem;
    background: rgba(0, 0, 0, 0.06);
    flex-shrink: 0;
  }

  > * {
    flex: 1;
  }

  ${PlaceholderParagraph} {
    margin: 0;
  }
`;

const PlaceholderHeaderComponent = (props: PlaceholderHeaderProps) => {
  const { image, children, className, style } = props;
  return (
    <Header className={cx(image && "is-image", className)} style={style}>
      {children}
    </Header>
  );
};

export const PlaceholderHeader = styled(PlaceholderHeaderComponent)``;
